<template>
  <div>
    <highcharts :id="id" class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
import highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'

exportingInit(highcharts)

var idx = 0

export default {
  props: {
    QuestM: {
      type: Object,
      default: () => {},
    },
    QuestD: {
      type: Array,
      default: () => {},
    },
  },
  created() {
    this.init()
  },
  data() {
    idx++
    return {
      id: 'ChartRadar' + String(idx),
      chartOptions: {
        chart: {
          polar: true,
          type: 'line',
        },

        accessibility: {
          description: '',
        },

        title: {
          text: this.QuestM.cnName,
          x: -80,
        },

        pane: {
          size: '80%',
        },

        xAxis: {
          categories: [],
          tickmarkPlacement: 'on',
          lineWidth: 0,
        },

        yAxis: {
          gridLineInterpolation: 'polygon',
          lineWidth: 0,
          min: 0,
        },

        tooltip: {
          shared: true,
          pointFormat:
            '<span style="color:{series.color};">{series.name}: <b>{point.y}</b><br/>',
        },

        legend: {
          align: 'right',
          verticalAlign: 'middle',
          layout: 'vertical',
        },

        series: [
          {
            name: '平均值',
            data: [],
            pointPlacement: 'on',
          },
        ],

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: 'center',
                  verticalAlign: 'bottom',
                  layout: 'horizontal',
                },
                pane: {
                  size: '70%',
                },
              },
            },
          ],
        },

        //
      },
    }
  },
  mounted() {
    
    var obj = {
      id: this.id,
      option: this.chartOptions,
    }

    this.$store.state.charts.push(obj)

    //   var chart = Highcharts.chart(this.id, this.chartOptions)
    //   this.$store.state.charts.push(chart)
  },
  methods: {
    init() {
      var countRe = 1 //檢查從是否重複使用 取得陣列各小題 題目名稱使用
      var QuestMatrix = [] //新的統計明細array 方便計算平均值
      var OptionsSum = 0
      var sum = 0
      for (let i = 0; i < this.QuestD.length; i++) {
        if (
          this.QuestD[i].serial == this.QuestM.serial &&
          this.QuestD[i].arraySerial != 0
        ) {
          //match到明細是陣列題目的
          if (countRe == this.QuestD[i].arraySerial) {
            //match到是此題目第一筆的
            this.chartOptions.xAxis.categories.push(this.QuestD[i].cnName) //寫進圖表資料
            window.console.log(this.QuestD[i].cnName)
            countRe++ //+1避免重複取得同樣題目
          }
          QuestMatrix.push(this.QuestD[i])
        }
      }
      //window.console.log(sum,OptionsSum)
      for (let i = 0; i < QuestMatrix.length; i++) {
        OptionsSum += parseInt(QuestMatrix[i].options) * parseInt(QuestMatrix[i].sum) //選項總和
        sum += parseInt(QuestMatrix[i].sum) //人數
        //window.console.log(QuestMatrix[i].cnName)
        if (i == QuestMatrix.length - 1) {
          //如果是最後一筆
          //window.console.log(sum,OptionsSum)
          this.chartOptions.series[0].data.push(parseFloat(OptionsSum / sum))
          sum = 0
          OptionsSum = 0
        } else if (QuestMatrix[i].arraySerial != QuestMatrix[i + 1].arraySerial) {
          //如果是這小題最後一筆
          //   window.console.log(sum,OptionsSum)
          //   window.console.log(parseFloat(OptionsSum/sum))
          this.chartOptions.series[0].data.push(parseFloat(OptionsSum / sum))
          sum = 0
          OptionsSum = 0
        }
      }
      //   window.console.log( this.chartOptions.series[0].data)
    },
  },
}
</script>
